import type { Badge } from 'commonTypes/api/scenarios/BaseTypes';
import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { modifyBadges } from 'entities/scenario';
import { addAdditionalBadges } from 'entities/scenario/lib/addAdditionalBadges';

export const modifyPreApprovalOfferBadges = (badges: MPLPreApprovalOffer['badges'] = [], description?: string) => {
  return addAdditionalBadges(
    modifyBadges(
      badges.map((badge: Badge) => ({
        ...badge,
        // todo разобраться, почему бэк:
        //  конкретно для предодобов возвращает текст в text, а не в title как у остальных элементов группы online,
        //  возвращает невалидный type "preApproval"
        title: (badge as any).text,
        type: 'primary',
      })),
    ),
    description,
  );
};
